import { ArrowUpBoldBoxIcon } from './ArrowUpBoldBoxIcon';

/**
 * author: Austin Andrews
 * id 062452EE-7669-4C36-85E6-A85BBA735348
 * name arrow-up-bold-box
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-up-bold-box.svg
 * tags
 * - Arrow 
 */
export const ArrowTopBoldBoxIcon = ArrowUpBoldBoxIcon;
export default ArrowTopBoldBoxIcon